import { z } from 'zod'

export const appointmentSettingsSchema = z.object({
  calendarId: z.string().min(1, 'Please select a calendar'),
  // [day][hour], true means available
  availability: z
    .array(z.array(z.boolean()))
    .length(7, 'Must include all 7 days')
    .refine(week => week.every(day => day.length === 24), {
      message: 'Each day must have 24 time slots',
    }),
})

export type AppointmentSettingsForm = z.infer<typeof appointmentSettingsSchema>

export const appointmentTypeSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  daysInAdvance: z.coerce.number().min(1, 'Must be 1 or more'),
  defaultMeetingLength: z.coerce
    .number()
    .int({ message: 'Must be a whole number' })
    .min(5)
    .refine(val => val % 15 === 0, {
      message: 'Must be in 15-minute increments',
    }),
})

export type AppointmentTypeForm = z.infer<typeof appointmentTypeSchema>

export const organizationSettingsFormSchema = z.object({
  timezone: z.string().min(1, { message: 'Timezone is required' }),
})

export type OrganizationSettingsForm = z.infer<
  typeof organizationSettingsFormSchema
>

export type AvailabilitySlot = {
  start: string
  end: string
}

export type accountLink = {
  object: string
  url: string
}

export type accountInfo = {
  isAuthorized: boolean
  integrationEmail: string
  provider: Provider
  calendarId: string
}

export type Calendar = {
  access_role: 'reader' | 'writer' | 'owner'
  background_color: string
  description: string
  etag: string
  foreground_color: string
  id: string
  is_owned_by_user: boolean
  is_primary: boolean
  is_read_only: boolean
  name: string
  object: 'Calendar'
  sync_activated: boolean
  sync_token: string | null
  timezone: string
}

export enum Provider {
  google = 'google',
  microsoft = 'microsoft',
  imap = 'imap',
}

export type TeamMember = {
  id: string
  firstName: string
  lastName: string
  email: string
  role: {
    id: string
    name: string
  }
}
